t = require('app/scripts/views/internal/teacup-with-helpers')('change_org_vis')

module.exports = ->
  t.li ->
    t.a '.highlight-icon.js-select-members', { href: '#' }, ->
      t.icon 'private', 'private'
      t.mustacheBlock 'permissionLevel_private', ->
        t.icon 'check'
      t.span '.sub-name', ->
        t.text t.mustacheVar('privateText')
  t.li ->
    t.a '.highlight-icon.js-select-public', { href: '#' }, ->
      t.icon 'public', 'public'
      t.mustacheBlock 'permissionLevel_public', ->
        t.icon 'check'
      t.span '.sub-name', ->
        t.text t.mustacheVar('publicText')
